window.addEventListener("DOMContentLoaded", function () {
    var container = document.querySelector('.image--scrollable');
    var scrollableImage = container.querySelector('img');

    // Calculate the initial scroll position to center the content
    var containerWidth = container.clientWidth;
    var scrollableImageWidth = scrollableImage.clientWidth;
    var initialScroll = (scrollableImageWidth - containerWidth) / 2;

    // Set the initial scroll position
    container.scrollLeft = initialScroll;
});